import { Link } from 'react-router-dom';
import { ProficoWordmark } from '../BrandLockup';
import { OnboardingBlock, FormCol } from './OnboardingTemplate.styles';

function OnboardingTemplate({ children }) {
  return (
    <OnboardingBlock>
      <FormCol>
        <div className="form-content">
          <Link className="brand_logo" to="/">
            <ProficoWordmark markSize={30} />
          </Link>
          {children}
        </div>
      </FormCol>
    </OnboardingBlock>
  );
}

export default OnboardingTemplate;
